import React from 'react';
import SearchableSelect from '../ui/SearchableSelect';
import { CURRENCY_NOT_SET, CURRENCY_OPTIONS, type ProjectCurrency } from '../../utils/currency';

export const PRIMARY_CURRENCY_LOCK_REASON =
  'This project already has money recorded (a budget item, payment, invoice, order or quote), so its main currency can no longer be changed. Individual documents can still use other currencies.';

interface Props {
  value: ProjectCurrency;
  /**
   * True once the project has any money row. Comes from the API's
   * `currency_locked` flag on the project settings.
   */
  locked: boolean;
  /** The person may not change project settings at all (not an owner). */
  readOnly?: boolean;
  onChange: (value: ProjectCurrency) => void;
}

/** The project's primary (reporting) currency: editable until the first money
 *  row exists, then read-only with a plain reason. No default currency. */
export default function PrimaryCurrencyField({ value, locked, readOnly = false, onChange }: Props) {
  return (
    <div className="form-group">
      <label>Main currency</label>
      {locked || readOnly ? (
        <>
          <div className="form-input form-input--readonly" data-testid="primary-currency-readonly">
            {value || CURRENCY_NOT_SET}
          </div>
          {locked && <p className="form-hint">{PRIMARY_CURRENCY_LOCK_REASON}</p>}
        </>
      ) : (
        <SearchableSelect
          value={value}
          placeholder="Select a currency"
          onChange={v => onChange(v as ProjectCurrency)}
          options={CURRENCY_OPTIONS}
        />
      )}
    </div>
  );
}
